module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUxpcf///////////////////////////////////////////20p1csAAAAMdFJOUwD+FdRShC7oxH21lCnGU6UAAAA/SURBVAjXY2CgHHA1gcjpCUCCQ1iBgYFVEMRkMjRiYAgUAatQFlZgFXQAM4HCUEGgsDhUECQsAjdP24GBKgAAqXIFsk7jZqIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_arrow_down@1x.png
// module id = U7FC
// module chunks = 4